import { em, rem, shade, tint } from 'polished'
import styled from 'styled-components'

interface IMentionsInputStyledProps {
  height?: number
}

export const MentionsInputStyled = styled.div<IMentionsInputStyledProps>`
  font-size: ${rem(16)};

  width: ${em(300, 12)};

  position: relative;

  .shortcut-instruction {
    margin-top: 0.5em;
    font-size: 0.6em;
  }
`
